// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Application Layout Styles */
.app-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-loading {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--primary-50) 0%, var(--secondary-50) 100%);
}

.app-loading p {
  margin-top: var(--space-4);
  color: var(--gray-600);
  font-size: var(--text-lg);
}

/* Responsive Design */
@media (max-width: 768px) {
  .app-loading p {
    font-size: var(--text-base);
    text-align: center;
    padding: 0 var(--space-4);
  }
}

@media (max-width: 480px) {
  .app-loading p {
    font-size: var(--text-sm);
    padding: 0 var(--space-2);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layout/AppLayout.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mFAAmF;AACrF;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;AACF","sourcesContent":["/* Application Layout Styles */\n.app-layout {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.app-loading {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, var(--primary-50) 0%, var(--secondary-50) 100%);\n}\n\n.app-loading p {\n  margin-top: var(--space-4);\n  color: var(--gray-600);\n  font-size: var(--text-lg);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .app-loading p {\n    font-size: var(--text-base);\n    text-align: center;\n    padding: 0 var(--space-4);\n  }\n}\n\n@media (max-width: 480px) {\n  .app-loading p {\n    font-size: var(--text-sm);\n    padding: 0 var(--space-2);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
